import React, { useEffect, useState } from "react";
import { add, format, getDayOfYear, getMonth, getWeek, isBefore, isEqual } from "date-fns";
import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "src/components";
import { theme } from "src/config";
import { DeliverableStore } from "src/stores";
import { rangeOfDateInterval, startOf } from "src/util/util";
import styled from "styled-components";

export interface IDelivHeaderRow {
  delivStore?: DeliverableStore;
  end:         Date;
  start:       Date;
  view:        "days" | "weeks" | "months";
}

export const DelivHeaderRow = inject("delivStore")(observer((props: IDelivHeaderRow) => {
  const { start, end, view, delivStore } = props;
  const { t, i18n } = useTranslation();
  
  const [autoSelectCell, setAutoSelectCell] = useState<string>(null)
 
  const cells = [];

  useEffect(() => {
    setAutoSelectCell('');
  }, [view]);

  useEffect(() => {
    setTimeout(() => {
      const el = document.getElementById(autoSelectCell);
      if(!el) return;

      el.scrollIntoView({
        behavior: 'auto',
        block: 'center',
        inline: 'center'
      });

    }, 2000);
  }, [autoSelectCell]);

  const currentDay   = new Date();

  const currentDate = {
    "days":   getDayOfYear(currentDay),
    "weeks":  getWeek(currentDay),
    "months": getMonth(currentDay) + 1,
  };


  for (let curDate = startOf(start, view); isBefore(curDate, end) || isEqual(curDate, end); curDate = add(curDate, { [view]: 1 })) {
    const d = format(curDate, "yyyy-MM-dd");
   
    const dateCount = {
      "days":   getDayOfYear(curDate),
      "weeks":  getWeek(curDate),
      "months": getMonth(curDate) + 1,
    };

    if ( currentDate[view] == dateCount[view] && !autoSelectCell) {
      setAutoSelectCell(('cell_' + dateCount[view]))
    }

    cells.push(
      <StickyHeader
      id      = {'cell_' + dateCount[view]}
      key     = {curDate.toString()}
      onClick = {() => {delivStore.setFilterValue("date", rangeOfDateInterval(curDate, view), true); delivStore.updateQuery()}}
      style   = {{background: currentDate[view] == dateCount[view] ? theme.color.grayDefault : theme.color.grayLightest}}
      >
        <Tooltip
          placement = "bottom"
          content   = {t("view_all_deliv_date") + " " + d}
        >
          <DateHeader>
          <strong>{dateCount[view]}</strong>
          <span>{d}</span>
          </DateHeader>
        </Tooltip>
      </StickyHeader>
    );
    }
  return (
    <>
      {cells}
    </>
  );
}));

const StickyHeader = styled.th`
  position: sticky; 
  z-index:  10;
  left:     0;
`

const DateHeader = styled.div`
  display:         flex;
  flex-direction:  column;
  justify-content: center;
  align-items:     center;
  width:           100%;
  height:          100%;
  padding:         0.5rem;
  gap:             0.25rem;

  strong {
    font-size: 2rem;
    color:     ${theme.color.grayDarkest}
  }
  span {
    font-size:   1rem;
    color:       ${theme.color.grayDarkest};
    white-space: nowrap;
  }
`